import Client from './HTTPClient';

const API = {
  list (request) {
    return Client.post('/api/frequencies/', request);
  },

  create (request) {
    return Client.post('/api/frequencies/new', request);
  }
};

export default API;
